import { render } from "./auth-password-reset.vue?vue&type=template&id=28f48941&scoped=true"
import script from "./auth-password-reset.vue?vue&type=script&lang=js"
export * from "./auth-password-reset.vue?vue&type=script&lang=js"

import "./auth-password-reset.vue?vue&type=style&index=0&id=28f48941&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f48941"]])

export default __exports__